/**
 * Block DnD event propagation if element have "data-no-dnd" attribute.
 * Reference: https://github.com/clauderic/dnd-kit/issues/477
 *
 * This is the PointerSensor variant of NoDnDDataAttributeMouseSensor.
 * It prevents drag activation on pointerdown when the target (or any
 * ancestor) carries the data-no-dnd attribute, which is necessary
 * because pointerdown fires before mousedown and would otherwise
 * bypass the MouseSensor's check at non-100% browser zoom levels.
 *
 * Usage:
 *  1. DnD sensors setup:
 *    const dndSensors = useSensors(useSensor(NoDnDDataAttributePointerSensor));
 *    ...
 *    <DndContext sensors={dndSensors}>...</DnDContext>
 *
 *  2. Attach "data-no-dnd" attribute to element
 *    <MyComponent data-no-dnd="true">...</MyComponent>
 */

import { PointerSensor } from '@dnd-kit/core';
import { PointerEvent } from 'react';

const handler = ({ nativeEvent }: PointerEvent) => {
  let currentElement = nativeEvent.target as HTMLElement;

  while (currentElement) {
    if (currentElement.dataset?.noDnd) {
      return false;
    }

    currentElement = currentElement.parentElement as HTMLElement;
  }

  return true;
};

export default class NoDnDDataAttributePointerSensor extends PointerSensor {
  static activators = [
    { eventName: 'onPointerDown', handler },
  ] as (typeof PointerSensor)['activators'];
}
